export const formatHttps = (str) => {
  const httpPattern = 'http://';
  const httpsPattern = 'https://';
  const httpsPatternPartial = '^(https://)?(https|$)?(?::|$)(?:/|$)(?:/|$)';
  const cleanUrl = str
    .replace(new RegExp(httpPattern, 'g'), '')
    .replace(new RegExp(httpsPatternPartial, 'g'), '');
  return (httpsPattern + cleanUrl).trim();
};
